import React from 'react';
import { Box, Typography } from '@mui/material';
import { InterventionLadderStepModel } from '../../../api-service/clients';
import { stepBackgrounds, stepColor } from './intervention-ladder-colors';

export const selectedStepColor = stepBackgrounds[stepBackgrounds.length - 1];

export function stepCardFrame(isSelected: boolean) {
  return {
    borderRadius: '6px',
    border: '1px solid rgba(24, 76, 97, 0.18)',
    overflow: 'hidden',
    outline: isSelected ? `4px solid ${selectedStepColor}` : 'none',
    outlineOffset: 3,
  };
}

export function stepCardColors(intensity: number) {
  return {
    bgcolor: stepColor(stepBackgrounds, intensity),
    color: intensity >= 0.5 ? '#ffffff' : '#16323d',
  };
}

export function stepCardDivider(intensity: number) {
  return { borderTop: '1px solid', borderColor: intensity >= 0.5 ? 'rgba(255, 255, 255, 0.25)' : 'rgba(22, 50, 61, 0.15)' };
}

export function StepCardHeading({ step, isSelected }: { step: InterventionLadderStepModel; isSelected: boolean }) {
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, minHeight: 24 }}>
        <Box sx={{ fontSize: '0.6875rem', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase' }}>Trin {step.step}</Box>
        {isSelected && (
          <Box
            sx={{
              px: 1,
              py: 0.25,
              borderRadius: '999px',
              bgcolor: 'rgba(255, 255, 255, 0.9)',
              color: selectedStepColor,
              fontSize: '0.6875rem',
              fontWeight: 700,
              letterSpacing: '0.06em',
            }}
          >
            VALGT
          </Box>
        )}
      </Box>
      <Typography component="div" sx={{ mt: 1, fontSize: '1.0625rem', fontWeight: 600, lineHeight: 1.3 }}>
        {step.title}
      </Typography>
    </>
  );
}

export function StepNumber({ value, label }: { value: string; label: string }) {
  return (
    <Box sx={{ justifySelf: 'start', display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
      <Box sx={{ fontSize: '1.75rem', fontWeight: 500, lineHeight: 1.15, fontVariantNumeric: 'tabular-nums' }}>{value}</Box>
      <Box sx={{ fontSize: '0.75rem', opacity: 0.8, mt: 0.25 }}>{label}</Box>
    </Box>
  );
}
